import React from 'react';
import {
  Button,
  Col,
  InputNumber,
  Modal,
  ModalProps,
  Row,
  Select,
  Space,
  Switch,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import SearchSelect2 from 'components/Inventory/MoveMerge/SearchSelect2';
import {
  Label,
  Loading,
  ScreenMask,
  SiteContent,
  message,
} from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  HTTP_STATUS_OK,
  LOADING_ICON_SIZE1,
} from 'constants/config';
import { addWarehousePostedTransferLine, splitWarehousePostedTransferLine } from 'services/inventory';
import {
  fetchProducts,
  getProductLotList,
} from 'services/product';
import { getProfileSettingValue } from 'utils';
import { EPTLineActionType, SourceType } from '.';

export enum EditableField {
  FromLocation,
  ToLocation,
};

type Props = ModalProps & {
  actionType?: EPTLineActionType,
  disableFields?: EditableField[],
  line: StringKAnyVPair;
  needLineData?: boolean;
  onSave: Function;
};

const SplitLineDialog = (props: Props) => {
  const { useState } = React;
  const [currentProduct, setCurrentProduct] = useState<StringKAnyVPair>({});
  const [expiredfilter, setExpiredFilter] = useState(true)
  const [fromLocation, setFromLocation] = useState<StringKAnyVPair>({});
  const [inited, setInited] = useState(false);
  const [isLoadingLot, setIsLoadingLot] = useState(false);
  const [lastLotVersion, setLastLotVersion] = useState(0);
  const [lockScreen, setLockScreen] = useState(false);
  const [lotEnable, setLotEnable] = useState(false);
  const [lotFilteredList, setLotFilteredList] = useState<StringKAnyVPair[]>([])
  const [lotList, setLotList] = useState<StringKAnyVPair[]>([]);
  const [lotUomInfo, setLotUomInfo] = useState<StringKAnyVPair>({});
  const [lotVersion, setLotVersion] = useState(0);
  // eslint-disable-next-line
  const [selectLotDialogVisible, setSelectLotDialogVisible] = useState(false);
  // eslint-disable-next-line
  const [selectedLot, setSelectedLot] = useState<StringKAnyVPair>({});
  const [splitQty, setSplitQty] = useState<number>();
  const [toLocation, setToLocation] = useState<StringKAnyVPair>({});
  const [uomEnable, setUomEnable] = useState(false);

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Space>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button
            disabled={!isSavable()}
            onClick={onSubmit}
            type="primary"
            style={{width: 76}}
          >
            OK
          </Button>
        </Space>
      </Row>
    );
  };

  const getLotNumber = async (id: string) => {
    setIsLoadingLot(true);
    try {
      const res = await getProductLotList(id);

      if (res.isSuccess) {
        setLotList(res.data)
        setLotVersion(lotVersion + 1);
      }
    } catch (error) {
      message.error({
        content: `Loaded lot list error: ${error}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setIsLoadingLot(false);
    }
  };

  const getProfileSettings = async () => {
    const res1 = await getProfileSettingValue('EnableLOT', '0');
    const res2 = await getProfileSettingValue('EnableUOM', '0');
    const le = res1 === '1';
    const ue = res2 === '1';

    console.log('l', props.line);
    setLotEnable(le);
    setUomEnable(ue);

    return [le, ue];
  };

  const getProductInfo = async (productCode: string) => {
    setLockScreen(true);
    try {
      const { products } = await fetchProducts({uniqueCode: productCode}) as any;

      if (Array.isArray(products) && products.length === 1) {
        setCurrentProduct(products[0]);

        return products[0];
      } else {
        message.error({
          content: 'Product not match',
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
      }
    } catch(e) {
      message.error({
        content: `Loaded product information error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setLockScreen(false);
    }
  };

  const handleEditLine = async (act: EPTLineActionType) => {
    //console.log('s', splitQty, fromLocation, toLocation, props.line);
    const { line } = props;
    const { postedTransferNum, postedTransferLineNum } = line;
    const param: StringKAnyVPair = {
      FromWarehouseNum: line.fromWarehouseNum,
      FromLocationNum: fromLocation.locationNum,
      ToWarehouseNum: line.toWarehouseNum,
      ToLocationNum: toLocation.locationNum,
      // @ts-ignore
      FulfillmentProductNum: line.fulfillmentProductNum,
      // @ts-ignore
      SKU: line.sku,
      LotNumber: line.lotNumber,
      Uom: line.uom,
      UomRate: line.uomRate,
      Quantity: splitQty || 0,
      Note: '',
    };

    (act === EPTLineActionType.Edit) && (param.Quantity = line.quantity);
    (act === EPTLineActionType.Edit) && (param.postedTransferLineNum = postedTransferLineNum);
    console.log(postedTransferNum, postedTransferLineNum, param);
    if (props.needLineData) {
      const {
        fromLocationCode,
        fromLocationNum,
        toLocationCode,
        toLocationNum,
      } = props.line;
      // eslint-disable-next-line
      const ld = {
        ...props.line,
        fromLocationCode: fromLocation.locationCode || fromLocationCode,
        fromLocationNum: fromLocation.locationNum || fromLocationNum,
        toLocationCode: toLocation.locationCode || toLocationCode,
        toLocationNum: toLocation.locationNum || toLocationNum,
      };

      //console.log('->', fromLocation, toLocation);
      /*props.onSave(ld);
      onCancel();
      return;*/
    }
    //if (act === EPTLineActionType.Edit) return;
    setLockScreen(true);
    try {
      const res = act === EPTLineActionType.Split ?
        await splitWarehousePostedTransferLine(
          postedTransferNum,
          postedTransferLineNum,
          param,
        ) :
        await addWarehousePostedTransferLine(postedTransferNum, param);
      // there need an editing fn
      //console.log('r', res);
      if (res && typeof res === 'object') {
        if (res.code === HTTP_STATUS_OK) {
          message.info({
            content: `${act === EPTLineActionType.Edit ? 'Edited' : 'Split'} line sucessfully`,
            duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
          });
          props.onSave(res.data);
          onCancel();
        }
      }
    } catch(e: any) {
      let showError = true;

      if (e.response && typeof e.response === 'object' && typeof e.response.data === 'object') {
        if (e.response.data.code === 400) showError = false;
      }

      showError && message.error({
        content: `Split line error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setLockScreen(false);
    }
  };

  const isFieldDisabled = (fn: EditableField) => {
    return props.disableFields && props.disableFields.indexOf(fn) > -1;
  };

  const isLocationConditionReady = () => {
    //return !!(currentProduct.sku && (isLotEnable(currentProduct) ? selectedLot.lotNumber : true));
    return !!currentProduct.sku;
  };

  const isLocationSelected = () => {
    return props.actionType === EPTLineActionType.Edit ?
      ((fromLocation.locationNum > 0 || toLocation.locationNum > 0) && (fromLocation.locationNum !== props.line.fromLocationNum || toLocation.locationNum !== props.line.toLocationNum)) :
      fromLocation.locationNum > 0 && toLocation.locationNum > 0;
  };

  const isLotEnable = (item: StringKAnyVPair) => {
    return lotEnable && item.lotControl === 1;
  };

  const isSavable = () => {
    return isLocationConditionReady() && (
      props.actionType === EPTLineActionType.Split ?
        (splitQty && splitQty > 0) : isLocationSelected()
    );
  };

  // eslint-disable-next-line
  const loadInitialData = async () => {
    const { line } = props;
    const [le] = await getProfileSettings();
    const prd = await getProductInfo(props.line.sku);

    setLotUomInfo({lotNumber: line.lotNumber, uom: line.uom, uomRate: line.uomRate});
    console.log('p', prd);
    le && prd && prd.lotControl === 1 && getLotNumber(prd.productId);

    (isFieldDisabled(EditableField.FromLocation)) && setFromLocation({
      locationCode: line.fromLocationCode,
      locationNum: line.fromLocationNum,
    });
    (isFieldDisabled(EditableField.ToLocation)) && setToLocation({
      locationCode: line.toLocationCode,
      locationNum: line.toLocationNum,
    });
  };

  const onCancel = () => {
    // @ts-ignore
    props.onCancel && props.onCancel();
  };

  const onChangeLocation = (lt: SourceType, ld: StringKAnyVPair) => {
    //console.log(lt, ld);
    if (ld.locationNum > 0) {
      if (lt === SourceType.From) {
        (fromLocation.locationNum !== ld.locationNum) && setFromLocation(ld);
      } else if (lt === SourceType.To) {
        (toLocation.locationNum !== ld.locationNum) && setToLocation(ld);
      }
    }
  };

  const onChangeLot = (ln: string) => {
    const lot = lotFilteredList.find(e => e.lotNumber === ln);
    //console.log('cl', ln, lot);
    setSelectedLot(lot || {});
    setLotUomInfo({
      ...lotUomInfo,
      lotNumber: lot ? lot.lotNumber : '',
    });
  };

  const onChangeSplitQty = (val: number) => {
    setSplitQty(val);
  };

  const onSubmit = () => {
    switch (props.actionType) {
      case EPTLineActionType.Edit:
      case EPTLineActionType.Split:
        handleEditLine(props.actionType);
        break;
    
      default:
        break;
    }
  };

  React.useEffect(() => {
    if (!inited) {
      loadInitialData();
      setInited(true);
    }

    if (lastLotVersion !== lotVersion) {
      if (expiredfilter){
        const temp = lotList.filter((i:any) => !(i.expirationDate && moment(i.expirationDate).diff(moment()) < 0));
        setLotFilteredList([...temp]);
      } else {
        setLotFilteredList([...lotList]);
      }

      setLastLotVersion(lotVersion);
    }
  }, [
    expiredfilter,
    lastLotVersion,
    loadInitialData,
    lotList,
    lotVersion,
    inited,
  ]);

  return (<>
    <Modal
      footer={dialogFooter()}
      onCancel={onCancel}
      {...props}
    >
      <SiteContent className="common-content">
        <Row>
          <Col>
            <Label className="label-bold tail-colon1">Identifier</Label>
            <span>{props.line.sku}</span>
          </Col>
        </Row>
        {false && isLotEnable(currentProduct) && (<>
          <Row align="middle" className="mt-12">
            <Col>
              <Label className="label-bold tail-colon1">Hide expired LOT#</Label>
              <Switch checked={expiredfilter} onChange={setExpiredFilter} checkedChildren="On" unCheckedChildren="Off"/>
            </Col>
          </Row>
          <Row align="middle" className="mt-8">
            <Col>
              <Label className="label-bold tail-colon1">LOT#</Label>
              <Space size="small">
                <Select
                  allowClear
                  loading={isLoadingLot}
                  onChange={onChangeLot}
                  optionFilterProp="label"
                  showSearch
                  style={{ width: 200 }}
                >
                  {lotFilteredList.map((i:any)=><Select.Option key={i.lotNumber} value={i.lotNumber} label={i.lotNumber}>{i.lotNumber}</Select.Option>)}
                </Select>
                <Button icon={<SearchOutlined />} onClick={()=>{setSelectLotDialogVisible(true)}}></Button>
              </Space>
            </Col>
          </Row>
        </>)}
        {uomEnable && (
          <Row className="mt-12">
            <Label className="label-bold tail-colon1">UOM</Label>
            <span>{props.line.uom}({props.line.uomRate})</span>
          </Row>
        )}
        <Row className="mt-12">
          {!isFieldDisabled(EditableField.FromLocation) && (
            <Col className="pr-8" span={props.needLineData ? 24 : 12}>
              <Row>
                <Label className="label-bold tail-colon1">From Warehouse</Label>
                <span>{props.line.fromWarehouseCode}</span>
              </Row>
              <Row align="middle" className="mt-8">
                <Label className="label-bold tail-colon1">From Location</Label>
                <div style={{width: 'calc(100% - 106px)'}}>
                  {isLocationConditionReady() && (
                    <SearchSelect2
                      defaultSelectOneOption={true}
                      defaultValue={props.actionType === EPTLineActionType.Edit ? (props.line.fromLocationNum || undefined) : undefined}
                      //defaultValue={props.line.fromLocationNum || undefined}
                      disabled={isFieldDisabled(EditableField.FromLocation)}
                      //form={recvForm}
                      locationQuery={lotUomInfo}
                      locationType={0}
                      onChange={(_, location) => onChangeLocation(SourceType.From, location)}
                      optionVersion={1}
                      product={currentProduct}
                      showPick
                      title="SLocation6"
                      useLastValue
                      warehouseId={props.line.fromWarehouseId}
                    />
                  )}
                </div>
              </Row>
            </Col>
          )}
          {!isFieldDisabled(EditableField.ToLocation) && (
            <Col span={props.needLineData ? 24 : 12}>
              <Row>
                <Label className="label-bold tail-colon1">To Warehouse</Label>
                <span>{props.line.toWarehouseCode}</span>
              </Row>
              <Row align="middle" className="mt-8">
                <Label className="label-bold tail-colon1">To Location</Label>
                <div style={{width: 'calc(100% - 88px)'}}>
                  {isLocationConditionReady() && (
                    <SearchSelect2
                      defaultSelectOneOption={true}
                      defaultValue={props.actionType === EPTLineActionType.Edit ? (props.line.toLocationNum || undefined) : undefined}
                      //defaultValue={props.line.toLocationNum || undefined}
                      disabled={isFieldDisabled(EditableField.ToLocation)}
                      //form={recvForm}
                      locationQuery={lotUomInfo}
                      locationType={0}
                      onChange={(_, location) => onChangeLocation(SourceType.To, location)}
                      optionVersion={1}
                      product={currentProduct}
                      showPick={false}
                      title="SLocation6"
                      useLastValue
                      warehouseId={props.line.toWarehouseId}
                    />
                  )}
                </div>
              </Row>
            </Col>
          )}
        </Row>
        {props.actionType === EPTLineActionType.Split && (
          <Row align="middle" className="mt-12">
            <Label className="label-bold tail-colon1">Quantity</Label>
            <InputNumber
              addonAfter={<span>Max({props.line.quantity - 1})</span>}
              disabled={!isLocationSelected()}
              onChange={onChangeSplitQty}
              max={props.line.quantity - 1}
              min={0}
              style={{width: 200}}
            />
          </Row>
        )}
      </SiteContent>
    </Modal>
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default SplitLineDialog;
